module.exports = __webpack_public_path__ + "static/media/communication.0735beca.svg";